// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17aIC","col":"styles_col__2yW6G"};